<amplify-authenticator [loginMechanisms]="['email']" [hideSignUp]="true" [services]="services" style="width: 100%">
    <ng-template amplifySlot="sign-in-header">
        <!--<h1 class="text-xl font-bold bg-primary text-white" style="padding: 1rem 1rem 1rem 2rem;">{{appTitle}}</h1>-->
        <div class="flex flex-row justify-center px-1 py-3" style="background-color: rgb(0, 52, 89)">
            <img src="../../assets/MAXI_logo_sm.png" height="28" width="93"  />
        </div>
    </ng-template>
    <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
        <!--<div class="logout">
            <h3>Already authenticated.</h3>
            <p-button label="Logout" icon="pi pi-exit" [size]="'small'" severity="warn" (click)="logout(); signOut()"/>
        </div>-->
    </ng-template>
</amplify-authenticator>
